import React, { useState } from 'react'
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {getStatusColor, formatPhoneNumber, completePercent} from '../../utils/utils';
import {addNote} from '../../api/APIServices';
import NumberCircle from '../../components/NumberCircle';
import {COLOR} from '../../constants/index'
import Note from '../Notes/Note';

function Alert({user, index}) {
    const {t} = useTranslation('global');
    const dispatch = useDispatch();
    // const {userAlerts, status} = useSelector((state)=> state.users );
    // const {noteStatus} = useSelector((state)=> state.user );
    
    const [openAddNote, setOpenAddNote] = useState(false);
    const[text, setText] = useState("");

    let bgColor = (index%2 === 0) ? COLOR.odd : COLOR.even;

    const handleClickOpenAddNote = () => {
      setOpenAddNote(true);
    };

    const handleCloseAddNote = () => {
        setText('');
        setOpenAddNote(false);
    };
    
    const handleChange = (userId) => {
        const noteObj = {
            note: text, 
            userId:userId
        }
        // dispatch(addNote({noteObj, userAlerts}));
        dispatch(addNote(noteObj));

        handleCloseAddNote();
        setText('');
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     setFormErrors(validate(formValues));
    //     setIsSubmit(true)
    // }

    const  sortFunction = (a,b) => {  
        var dateA = new Date(a.date).getTime();
        var dateB = new Date(b.date).getTime();
        return dateA < dateB ? 1 : -1;  
    };

    const allNote = user.notes ? [...user.notes] : [];
    allNote.sort(sortFunction);
  return (
    <>
        <TableRow sx={{backgroundColor:`${bgColor}`}}>
            <TableCell align="left">
                <Link style={{ color: '#028DD5', textDecoration: 'inherit'}} 
                    to={`/user_details/${user.userId}`}
                > 
                  {user.firstName}
                </Link>
            </TableCell>
            <TableCell align="left">
                <Link style={{ color: '#028DD5', textDecoration: 'inherit'}} to={`/user_details/${user.userId}`}> 
                  {user.lastName}
                </Link>
            </TableCell>
            <TableCell width="10%" align="left">
                {formatPhoneNumber(user.phone)}
            </TableCell>

            <TableCell width="7%" align="center">
                <NumberCircle  color={getStatusColor(user.compliance.education)}>
                {completePercent(user.compliance.education)}

                  
                </NumberCircle>
            </TableCell>
            <TableCell width="7%" align="center">
                <NumberCircle  color={getStatusColor(user.compliance.questionnaire)}>
                  
                    {completePercent(user.compliance.questionnaire)}

                    </NumberCircle>
            </TableCell>
            <TableCell width="7%" align="center">
                <NumberCircle  color={getStatusColor(user.compliance.exercise)}>
                  
                    {completePercent(user.compliance.exercise)}

                    </NumberCircle>
            </TableCell>

            <TableCell width="50%" align="left">
                <div style={{maxHeight:"80px", overflow:'auto', scrollbarWidth:'thin'}}>
                {allNote && allNote.map(note => (
                    <Note key={note.noteId} note={note} />
                ))}
                </div>
            </TableCell>

            <TableCell width="5%" align="center">
                <Button 
                    variant="outlined" 
                    onClick={handleClickOpenAddNote}
                    sx={{marginRight:1,textTransform: "none", padding: "0px"}} 
                    size="small">Add Note
                </Button>
                <Dialog
                    open={openAddNote}
                    onClose={handleCloseAddNote}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "600px",
                        display: 'flex',
                        fontFamily: 'Open Sans'
                        },
                    },
                    }}
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("add_note")}
                    </DialogTitle>
                    <DialogContent>
                        <div style={{ display: 'flex', marginBottom: '10px', marginTop: '10px' }}>
                           
                                <TextField sx={{
                                marginBottom:'10px',
                                scrollbarWidth:'thin'
                                }}
                                cols={18}
                                rows={4}
                                size="small"
                                id="outlined-basic"
                                label={t('type_your_note')} 
                                variant="outlined" 
                                multiline={true}
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                fullWidth={true}
                            />
                            
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            type="submit"
                            color='primary'
                            variant="contained"
                            autoFocus
                            onClick={() => handleChange(user.userId)}
                        >
                        {t('add')}
                        </Button>
                        <Button
                            size='small'
                            onClick={handleCloseAddNote}
                        >
                        {t('cancel')}
                        </Button>
                    </DialogActions>
                 
                </Dialog>
            </TableCell>
        </TableRow>
    </>
  )
}

export default Alert